import React from 'react';
import { Helmet } from "react-helmet";

const TermsConditions = () => {
  return (
    <>
      <Helmet>
        <title>Tulvod - Ihr Experte fuer urbane Mobilitaet</title>
        <meta name="description" content="Tulvod - Entdecken Sie die besten Tipps, Routen und Informationen rund um Fahrradverleih und urbane Mobilitaet in Deutschland. Ihr Experte fuer Fahrradtouren und nachhaltige Fortbewegung." />
      </Helmet>

      <div className="policy-container">
      <h1>Allgemeine Geschäftsbedingungen</h1>
      <p><strong>Letzte Aktualisierung:</strong> {new Date().toLocaleDateString('de-DE')}</p>

      <section>
        <h2>1. Geltungsbereich</h2>
        <p>
          Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge, Lieferungen und sonstigen 
          Leistungen zwischen dem Betreiber der Website tulvod-de.com (nachfolgend "Anbieter" genannt) und 
          seinen Kunden (nachfolgend "Nutzer" genannt).
        </p>
        <p>
          Fahrradverleih Service<br />
          Ederring 7<br />
          01775 Starnberg<br />
          Deutschland<br />
          Telefon: +4990874455288<br />
          E-Mail: tulvod@hotmail.com
        </p>
        <p>
          Mit der Nutzung unserer Website und unserer Dienstleistungen erklären Sie sich mit diesen AGB 
          einverstanden. Abweichende Bedingungen des Nutzers werden nicht anerkannt, es sei denn, der 
          Anbieter stimmt ihrer Geltung ausdrücklich schriftlich zu.
        </p>
      </section>

      <section>
        <h2>2. Leistungsumfang</h2>
        <h3>2.1 Informationsangebot</h3>
        <p>
          Der Anbieter betreibt einen Blog zum Thema Fahrradverleih, urbane Mobilität, Fahrradtouren und 
          nachhaltige Fortbewegung in Deutschland. Die Website bietet:
        </p>
        <ul>
          <li>Informative Blogartikel über Fahrradverleih und Mobilität</li>
          <li>Tipps und Empfehlungen für Fahrradtouren</li>
          <li>Informationen über Radwege und Routen</li>
          <li>Newsletter-Service</li>
          <li>Kontaktmöglichkeiten</li>
        </ul>

        <h3>2.2 Verfügbarkeit</h3>
        <p>
          Der Anbieter bemüht sich um eine möglichst unterbrechungsfreie Verfügbarkeit der Website. Eine 
          Gewährleistung für die ständige Verfügbarkeit kann jedoch nicht übernommen werden. Der Anbieter 
          behält sich das Recht vor, die Website jederzeit ganz oder teilweise zu ändern oder einzustellen.
        </p>
      </section>

      <section>
        <h2>3. Vertragsschluss</h2>
        <h3>3.1 Nutzung der Website</h3>
        <p>
          Die Nutzung der Website ist grundsätzlich kostenfrei. Mit dem Zugriff auf die Website kommt ein 
          Nutzungsvertrag zwischen dem Nutzer und dem Anbieter zustande, der diese AGB zum Gegenstand hat.
        </p>

        <h3>3.2 Newsletter-Anmeldung</h3>
        <p>
          Durch die Anmeldung zum Newsletter erklärt sich der Nutzer damit einverstanden, regelmäßig 
          Informationen per E-Mail zu erhalten. Die Anmeldung erfolgt im Double-Opt-In-Verfahren. Der 
          Nutzer kann den Newsletter jederzeit über den in jeder E-Mail enthaltenen Abmeldelink abbestellen.
        </p>

        <h3>3.3 Kontaktaufnahme</h3>
        <p>
          Anfragen über das Kontaktformular oder per E-Mail stellen noch kein verbindliches Angebot dar. 
          Ein Vertrag kommt erst durch die ausdrückliche Annahme durch den Anbieter zustande.
        </p>
      </section>

      <section>
        <h2>4. Pflichten und Verantwortlichkeiten des Nutzers</h2>
        <h3>4.1 Nutzungsverhalten</h3>
        <p>Der Nutzer verpflichtet sich:</p>
        <ul>
          <li>Die Website nur für rechtmäßige Zwecke zu nutzen</li>
          <li>Keine falschen oder irreführenden Informationen bereitzustellen</li>
          <li>Keine schädliche Software oder Codes zu übertragen</li>
          <li>Die Rechte Dritter (insbesondere Urheber-, Marken- und Persönlichkeitsrechte) zu respektieren</li>
          <li>Keine automatisierten Systeme oder Software zur Extraktion von Daten zu verwenden</li>
        </ul>

        <h3>4.2 Haftung für bereitgestellte Inhalte</h3>
        <p>
          Für alle vom Nutzer bereitgestellten Inhalte (z.B. Kommentare, Anfragen über das Kontaktformular) 
          ist ausschließlich der Nutzer verantwortlich. Der Nutzer stellt den Anbieter von allen Ansprüchen 
          Dritter frei, die aufgrund rechtswidriger Inhalte des Nutzers geltend gemacht werden.
        </p>
      </section>

      <section>
        <h2>5. Urheberrecht und Nutzungsrechte</h2>
        <h3>5.1 Rechte des Anbieters</h3>
        <p>
          Alle auf der Website veröffentlichten Inhalte (Texte, Bilder, Grafiken, Videos, Logos etc.) sind 
          urheberrechtlich geschützt. Die Rechte liegen beim Anbieter oder bei den jeweiligen Rechteinhabern, 
          die der Veröffentlichung zugestimmt haben.
        </p>

        <h3>5.2 Nutzungsbeschränkungen</h3>
        <p>
          Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen 
          des Urheberrechts bedürfen der schriftlichen Zustimmung des Anbieters. Downloads und Kopien dieser 
          Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
        </p>
      </section>

      <section>
        <h2>6. Haftung</h2>
        <h3>6.1 Haftung für Inhalte</h3>
        <p>
          Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, 
          Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als 
          Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den 
          allgemeinen Gesetzen verantwortlich.
        </p>

        <h3>6.2 Haftung für Links</h3>
        <p>
          Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss 
          haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte 
          der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
        </p>

        <h3>6.3 Haftungsbeschränkung</h3>
        <p>
          Der Anbieter haftet unbeschränkt für Vorsatz und grobe Fahrlässigkeit. Für leichte Fahrlässigkeit 
          haftet der Anbieter nur:
        </p>
        <ul>
          <li>Bei Verletzung einer wesentlichen Vertragspflicht</li>
          <li>Bei Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit</li>
          <li>Im Rahmen einer Garantie oder nach dem Produkthaftungsgesetz</li>
        </ul>
      </section>

      <section>
        <h2>7. Datenschutz</h2>
        <p>
          Die Verarbeitung personenbezogener Daten erfolgt im Einklang mit den geltenden Datenschutzgesetzen, 
          insbesondere der Datenschutz-Grundverordnung (DSGVO). Ausführliche Informationen zum Datenschutz 
          finden Sie in unserer separaten Datenschutzerklärung.
        </p>
      </section>

      <section>
        <h2>8. Schlussbestimmungen</h2>
        <h3>8.1 Änderungen der AGB</h3>
        <p>
          Der Anbieter behält sich das Recht vor, diese AGB jederzeit zu ändern. Die jeweils aktuelle Fassung 
          ist auf der Website einsehbar. Bereits geschlossene Verträge bleiben von Änderungen unberührt, 
          sofern der Nutzer den geänderten Bedingungen nicht zustimmt.
        </p>

        <h3>8.2 Salvatorische Klausel</h3>
        <p>
          Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die Wirksamkeit der 
          übrigen Bestimmungen hiervon unberührt. An die Stelle der unwirksamen Bestimmung tritt eine 
          Regelung, die dem wirtschaftlichen Zweck der unwirksamen Bestimmung am nächsten kommt.
        </p>

        <h3>8.3 Anwendbares Recht und Gerichtsstand</h3>
        <p>
          Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts. Gerichtsstand 
          für alle Streitigkeiten ist, soweit gesetzlich zulässig, der Sitz des Anbieters in Starnberg.
        </p>

        <h3>8.4 Streitbeilegung</h3>
        <p>
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
          https://ec.europa.eu/consumers/odr. Unsere E-Mail-Adresse finden Sie oben in unserem Impressum.
        </p>
        <p>
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
          Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </section>

      <section>
        <h2>9. Kontakt</h2>
        <p>
          Bei Fragen zu diesen Allgemeinen Geschäftsbedingungen wenden Sie sich bitte an:
        </p>
        <p>
          Fahrradverleih Service<br />
          Ederring 7<br />
          01775 Starnberg<br />
          Deutschland<br />
          E-Mail: tulvod@hotmail.com<br />
          Telefon: +4990874455288
        </p>
      </section>

      <section>
        <h2>10. Besondere Hinweise</h2>
        <h3>10.1 Informationscharakter</h3>
        <p>
          Alle auf dieser Website bereitgestellten Informationen zu Fahrradverleih, Routen und Touren dienen 
          ausschließlich der allgemeinen Information und stellen keine rechtsverbindliche Beratung dar. 
          Nutzer sollten aktuelle Informationen bei den jeweiligen Verleihstationen oder lokalen Behörden 
          einholen.
        </p>

        <h3>10.2 Keine Gewährleistung für Empfehlungen</h3>
        <p>
          Empfehlungen zu Routen, Verleihstationen oder anderen Dienstleistungen Dritter erfolgen ohne 
          Gewähr. Der Anbieter übernimmt keine Haftung für die Qualität, Verfügbarkeit oder Eignung der 
          empfohlenen Leistungen.
        </p>

        <h3>10.3 Aktualität der Informationen</h3>
        <p>
          Obwohl wir uns bemühen, alle Informationen aktuell zu halten, können sich Öffnungszeiten, Preise, 
          Verfügbarkeiten und andere Details bei Drittanbietern jederzeit ändern. Nutzer werden gebeten, 
          wichtige Informationen vor der Nutzung zu verifizieren.
        </p>
      </section>
    </div>
  
    </>);
};

export default TermsConditions;